import { RootState } from '../store/configureStore';

export const getAvailableBanks = (state: RootState) => state?.availableBanks?.availableBanks;

export const isFetchinAvailableBanks = (state: RootState) =>
  state?.availableBanks?.isFetchingAvailableBanks;

export const didFetchingAvailableBanksFailed = (state: RootState) =>
  state?.availableBanks?.fetchingAvailableBanksFailed;
